import { render } from "./ProjectSettings.vue?vue&type=template&id=5fd78ff8"
import script from "./ProjectSettings.vue?vue&type=script&lang=js"
export * from "./ProjectSettings.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__